import classNames from 'classnames';
import {observer} from 'mobx-react';
import React, {useEffect} from 'react';

import {useI18n} from '@udemy/i18n';
import {ShoppingClient, CouponStore} from '@udemy/shopping';

import {getConfig} from 'src/features/cart/config';

import {CheckoutButton} from '../checkout-button/checkout-button.react-component';
import {RedeemCouponWithCartCouponStore} from '../redeem-coupon/redeem-coupon-with-cart-coupon-store.react-component';
import {TotalPrice} from '../total-price/total-price.react-component';
import styles from './checkout-pane.module.less';

interface CheckoutPaneProps {
    couponStore?: CouponStore;
    checkoutButtonRef?: React.Ref<HTMLDivElement>;
}

export const CheckoutPane: React.FC<CheckoutPaneProps> = observer(
    ({couponStore, checkoutButtonRef}) => {
        const {gettext, interpolate, ngettext} = useI18n();
        const config = getConfig(gettext, interpolate, ngettext);
        useEffect(() => {
            ShoppingClient.validateDiscounts();
        }, []);

        if (ShoppingClient.lists.cart.isEmpty) {
            return null;
        }

        return (
            <div>
                <TotalPrice listName="cart" canShowCredit={true} />

                <div ref={checkoutButtonRef}>
                    <CheckoutButton
                        className={classNames([styles['pane-checkout-button']])}
                        triggerMwebCartClickEvent={true}
                        authNextUrl={config.urls.cartPage}
                    />
                </div>
                {couponStore && (
                    <div className={classNames(styles['redeem-coupon-wrapper'])}>
                        <RedeemCouponWithCartCouponStore
                            couponStore={couponStore}
                            isInCheckoutPane={true}
                        />
                    </div>
                )}
            </div>
        );
    },
);
